module.exports = __webpack_public_path__ + "resources/img/img-secuve-tos-04.08486e1045c198a8d66b35e655a96f80.png";